import React from "react";

const Backend = () => {
    return (
        <div className="skills_content">
            <h3 className="skills_title">Backend Geliştirme</h3>

            <div className="skills_box">
                <div className="skills_group">
                    <div className="skills_data">
                    <i class='bx bx-badge-check'></i>

                    <div>
                        <h3 className="skills_name">PHP</h3>
                        <span className="skills_level">Giriş</span>
                    </div>
                    </div>

                    <div className="skills_data">
                    <i class='bx bx-badge-check'></i>

                    <div>
                        <h3 className="skills_name">Node JS</h3>
                        <span className="skills_level">Giriş</span>
                    </div>
                    </div>

                    <div className="skills_data">
                    <i class='bx bx-badge-check'></i>

                    <div>
                        <h3 className="skills_name">C/C++</h3>
                        <span className="skills_level">Orta</span>
                    </div>
                    </div>
                </div>

                <div className="skills_group">
                    <div className="skills_data">
                    <i class='bx bx-badge-check'></i>

                    <div>
                        <h3 className="skills_name">MySQL</h3>
                        <span className="skills_level">Orta</span>
                    </div>
                    </div>

                    <div className="skills_data">
                    <i class='bx bx-badge-check'></i>

                    <div>
                        <h3 className="skills_name">SQL</h3>
                        <span className="skills_level">Giriş</span>
                    </div>
                    </div>

                    <div className="skills_data">
                    <i class='bx bx-badge-check'></i>

                    <div>
                        <h3 className="skills_name">C#</h3>
                        <span className="skills_level">Giriş</span>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Backend;